export default "__VITE_ASSET__o2IhF53q__"